//import $ from 'jquery';
import * as appConstants from "../overrides/appconstants";

export function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function deleteCookie() {
  let key = "authKey";
  if (document.cookie) {
    document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    return true;
  }
  return false;
}

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}
export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  let results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export function getSystemName(systemId, systems) {
  switch (systemId) {
    case appConstants.SYSTEM_ID_MEDICAL_CORE_ID:
      return appConstants.SYSTEM_ID_MEDICAL_CORE_TEXT;
    case appConstants.SYSTEM_ID_SECURITY:
      return appConstants.SYSTEM_ID_MEDICAL_SECURITY_TEXT;
    case appConstants.SYSTEM_ID_MOTOR_CORE_ID:
      return appConstants.SYSTEM_ID_MOTOR_CORE_TEXT;
    default:
      return "";
  }
}

export function getDefaultYearFirstDate() {
  const now = new Date(); // create a new date object for the current time
  const defaultYear = now.getFullYear(); // get the current year
  const firstDate = new Date(defaultYear, 0, 1); // create a new date object for January 1st of the current year
  return firstDate;
}
export function getAsOfNowDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getWorkFlowStatusBadge(workflowStatus) {
  const workflowStatusBadge = {
    324 : "badge bg-success",
    325 : "badge bg-success",
    326 : "badge bg-danger",
    327 : "badge bg-danger",
  }
  return workflowStatusBadge[workflowStatus] || "badge bg-warning";
}
export function addCommasToValue(value) {
  // Convert value to string
  value = value.toString();

  // Split the value into integer and decimal parts (if any)
  const parts = value.split('.');
  let integerPart = parts[0];
  const decimalPart = parts[1] || '';

  // Add commas to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Join the integer and decimal parts (if any)
  const formattedValue = decimalPart.length > 0 ? integerPart + '.' + decimalPart : integerPart;

  return formattedValue;
}
export function isDate(value) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return dateRegex.test(value);
}

export function getStatusBadge(fieldValue) {
  switch (fieldValue) {
    case "Open":
      return "badge bg-primary";
    case "Closed":
      return "badge bg-secondary text-light";
    case "Approved":
      return "badge bg-success";
    case "Not Approved":
      return "badge bg-danger";
    case "Under Process":
      return "badge bg-warning";
    case "Under Progress":
      return "badge bg-warning";
    case "Pending":
      return "badge bg-danger";
    case "Completed":
      return "badge bg-light text-dark";
    case "Abstained":
      return "badge bg-dark text-light";
    case "Expired":
      return "badge bg-danger";
    case "Confirmed":
      return "badge bg-success";
    default:
      return "";
  }
}
export function trimText(text, maxLength) {
  if (text.length <= maxLength) {
    return text; // No trimming needed
  }
  // Trim the text and append "..." at the end
  const trimmedText = text.slice(0, maxLength - 3) + "...";
  return trimmedText;
}
export function getCurrentDate() {
  var currentDate = new Date().toISOString().substr(0, 10);
  // console.log("Date.now() ", Date.now(),date2234 );
  // var obj = new Date();
  // var day=obj.getDate();
  // var month=obj.getMonth() + 1;
  // var year=obj.getFullYear();
  // var currentDate =  year+ "-" + month+ "-" + day;
  return currentDate;
}
export function getMinusOneYearToCurrentDate() {
  //var currentDate = new Date().toISOString().substr(0, 10);
   var obj = new Date();
  // var day=obj.getDate();
  // var month=obj.getMonth() + 1;
   obj.setFullYear(obj.getFullYear()-1);
  // var currentDate =  year+ "-" + month+ "-" + day;
  return obj.toISOString().substr(0, 10);;
}